import React from 'react';

import ProductListPackageCardActions from './components/product-list-package-card-actions/product-list-package-card-actions';
import ProductListPackageCardHeader from './components/product-list-package-card-header/product-list-package-card-header';
import ProductListCardDetails from '../product-list-card-details/product-list-card-details';
import ProductListCardHighlight from '../product-list-card-highlight/product-list-card-highlight';
import ProductListCardPromos from '../product-list-card-promos/product-list-card-promos';

import { useProductQuantity } from '../../../../shared/hooks/hooks';

import { BundleType } from '../../../../shared/types/graphql-types';
import { BundleData, ProductItem } from '../../../../shared/types/product';

import './product-list-package-card.scss';

interface ProductListPackageCardProps {
  onAddProductClick: (productItem: ProductItem) => void;
  onCheckInventoryClick: () => void;
  onViewProductClick: () => void;
  pageNum?: number;
  prebuiltPackage: BundleData;
}

function ProductListPackageCard(props: ProductListPackageCardProps) {
  const {
    onAddProductClick,
    onCheckInventoryClick,
    onViewProductClick,
    pageNum,
    prebuiltPackage
  } = props;

  const { product1, product2, url: productDetailUrl = '' } = prebuiltPackage;
  const { defaultQuantity, quantity, setQuantity, totalQuantity } =
    useProductQuantity({
      bundleType: BundleType.TireWheelPackage
    });

  if (!product1 || !product2) return null;

  if (window['isPreRendering']) {
    return <div styleName="container" />;
  }

  return (
    <div
      data-testid="product-list-package-card"
      id={product1 && product1.code ? `product-code-${product1.code}` : ''}
      styleName="container"
    >
      <ProductListCardHighlight product={product1} />
      <ProductListPackageCardHeader
        prebuiltPackage={prebuiltPackage}
        quantity={quantity}
      />
      <hr styleName="package-divider" />
      <ProductListCardDetails
        hideAvailability
        hideCompare
        hideFoundItLower
        hideReviews
        onCheckInventoryClick={onCheckInventoryClick}
        onViewProductClick={onViewProductClick}
        pageNum={pageNum}
        product={product1}
        productDetailUrl={productDetailUrl}
        quantity={quantity}
        showPriceInDescription
        totalQuantity={totalQuantity}
      />
      <hr styleName="package-divider" />
      <ProductListCardDetails
        hideAvailability
        hideFoundItLower
        onCheckInventoryClick={onCheckInventoryClick}
        onViewProductClick={onViewProductClick}
        pageNum={pageNum}
        product={product2}
        productDetailUrl={productDetailUrl}
        quantity={quantity}
        showPriceInDescription
        totalQuantity={totalQuantity}
      />
      <ProductListCardPromos product={prebuiltPackage} quantity={quantity} />
      <ProductListPackageCardActions
        defaultQuantity={defaultQuantity}
        onAddProductClick={onAddProductClick}
        onQuantityChange={setQuantity}
        prebuiltPackage={prebuiltPackage}
        quantity={quantity}
        totalQuantity={totalQuantity}
      />
    </div>
  );
}

export default ProductListPackageCard;
